import { Component, inject, Input } from '@angular/core';
import { AppConfig } from '../../../appconfig';

@Component({
  selector: 'lfw-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  standalone: true,
  imports: []
})
export class LogoComponent {
  @Input() showVersion = false;
  private config = inject(AppConfig);

  get longVersion() {
    return 'Version ' + this.config.version();
  }
  get shortVersion() {
    return 'V' + this.config.version();
  }
}
